import React from 'react';
import { RadioGroup as ChakraRadioGroup, RadioGroupProps as ChakraRadioGroupProps } from '@chakra-ui/react';

export function RadioGroup(props: ChakraRadioGroupProps) {
  return <ChakraRadioGroup {...props} />;
}
